/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { avgIcpXdrConversionRatesGetApiV3AvgIcpXdrConversionRates } from "../../funcs/avgIcpXdrConversionRatesGetApiV3AvgIcpXdrConversionRates.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3AvgIcpXdrConversionRatesRequest$inboundSchema
    .optional(),
};

export const tool$avgIcpXdrConversionRatesGetApiV3AvgIcpXdrConversionRates:
  ToolDefinition<typeof args> = {
    name:
      "avg-icp-xdr-get-api-v3-avg-icp-xdr-conversion-rates",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await avgIcpXdrConversionRatesGetApiV3AvgIcpXdrConversionRates(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
